<app-report-header [report]="report"></app-report-header>
<div class="report-container container">
  <div class="row report-overview-message">
    <div class="col-12">
      <a (click)="_locationService.back();">
        <svg width="11px" height="11px" viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Retour</title>
          <desc>Created with Sketch.</desc>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
            stroke-linejoin="round">
            <g id="UI-Rapport" transform="translate(-168.000000, -113.000000)" stroke="#162C4B">
              <g id="Title" transform="translate(168.000000, 105.000000)">
                <g id="arrow-left" transform="translate(0.000000, 8.000000)">
                  <path d="M10.5,5.5 L0.5,5.5" id="Path"></path>
                  <polyline id="Path" points="5.5 0.5 0.5 5.5 5.5 10.5"></polyline>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </a>
      <span class="report-title" i18n="report|@@report_date"> Rapport du {{report?.createdAt | date:'longDate'}}</span>
    </div>
  </div>
  <div class="row report-summary" id='report-sub'>
    <div class="col-12">
      <div class="report-summary-container fluid-container">
        <app-report-summary [report]='report' [reportId]="report?.id"></app-report-summary>
      </div>
    </div>
  </div>
  <div class="row report-body">
    <div class="d-none d-lg-block col-lg-3">
      <app-report-scrollspy [activeSection]="currentSection" [numberDamage]="report?.tchekPtr?.numberDamage"
        [report]="report"></app-report-scrollspy>
    </div>
    <div class="col-12 col-lg-9" appScrollSpyMenu [spiedTags]="['DIV']" [scrollOffset]="topNavHeight()"
      (sectionChange)="onSectionChange($event)">
      <div id="report-analysis" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-damage-analysis [reportId]="report?.id" [tchekId]="report?.tchekPtr?.id"></app-damage-analysis>
      </div>
      <div *ngIf="showPreselection" id="report-preselection" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-preselection [tchekId]="report?.tchekPtr?.id"></app-preselection>
      </div>
      <div id="report-signatory" *ngIf="showSignatory" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-signatory [reportId]="report?.id"></app-signatory>
      </div>
      <div id="report-vehicle" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-vehicle (newClassEmitter)='updateClass($event)'
		 [vehicleId]="report?.tchekPtr?.vehiclePtr?.id"
		  [tchekId]="report?.tchekPtr?.id"></app-vehicle>
      </div>
	  
      <div id="report-checklist" class="section-wrapper">
        <p class="section-scroll-anchor" *ngIf="report?.tchekPtr?.vehiclePtr?.id"></p>
        <app-report-check-list [newClass]="settings?.vehicle?.classes[0]?.value" [vehicleSettings]="settings?.vehicle"  [report]="report" [vehicleId]="report?.tchekPtr?.vehiclePtr?.id" ></app-report-check-list>
      </div>
      <div id="annex_picture" class="section-wrapper">
        <p class="section-scroll-anchor" *ngIf="report"></p>
        <app-annex-picture  [tchekId]="report?.tchekPtr?.id" [tchekPtr]="report?.tchekPtr">
      </app-annex-picture>
      </div>

      <!-- <div id="report-description" *ngIf="showVehicleDetails" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-vehicle-description [reportId]="report?.id" [report]='report'></app-vehicle-description>
      </div> -->
      <!-- <div id="report-interior" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-interior></app-interior>
      </div> -->
      <div id="report-tires" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-tires></app-tires>
      </div>
      <div id="report-details" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-report-details [report]='report'></app-report-details>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/report/report.component.html